
import React, { Fragment } from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import Form from 'react-bootstrap/Form';
import { faSearch, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppButton from "components/Button/Button";
import { getMetaConfig, getDropdownData } from "helpers/ConfigHelper";
import WorkList from 'components/Work/WorkList/WorkList';
import ObjectList from 'components/Object/ObjectList/ObjectList';
import ItemList from 'components/Item/ItemList/ItemList';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import MiniPagination from 'components/MiniPagination/MiniPagination';
import AppDropdown from 'components/Dropdown/Dropdown';
import { getSearchFields } from "helpers/FieldHelper";
import { checkRentItemFilter } from "helpers/FilterHelper";
import { isHome } from "helpers/AppHelper";


import "./WorkFilter.scss"

const WorkFilter = observer(
    class WorkFilter extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
                wpView: ConfigTypes.WORK_LIST,
                viewMode: ConfigTypes.WORK_FILTER,
                form: {},
                tabClasses: {},
                clStyles: { [ConfigTypes.WORK_LIST]: ConfigTypes.BTN_ACTIVE },
                tabCurrentPage: 0,
                tabTotalPages: 0,
                isListView: true,
                searchFullText: ''
            }
        }

        isActiveTab = ({ item }) => {
            const { workFilterCurrentTab }
                = this.props.mediaObjects;
            if ((workFilterCurrentTab && workFilterCurrentTab.name === item.name) || (!workFilterCurrentTab && item.active)) {
                return true;
            }
            return false;
        }

        initData = () => {
            const { itemTotalPages, totalPages, currentPage, itemCurrentPage, itemKeyword, objectKeyword, workFilterCurrentTab, workFilterObj }
                = this.props.mediaObjects;
            let itemSearch = false;
            let tabCurrentPage = currentPage || 1;
            let tabTotalPages = totalPages || 1;
            let searchFullText = objectKeyword || '';

            ConfigTypes.WORKFILTER_TABS.forEach(item => {
                let data = getMetaConfig({ viewMode: ConfigTypes.WORK_FILTER, props: this.props, configName: item.configName });
                if (data && data.length) this.setState({ [`${item.part}_data`]: data, [`${item.part}_searchSortCurrent`]: data[0] });
                if (this.isActiveTab({ item })) {
                    if (item.name == ConfigTypes.TAB_ITEM) {
                        itemSearch = true;
                        searchFullText = itemKeyword;
                        if (itemCurrentPage) tabCurrentPage = itemCurrentPage;
                        if (itemTotalPages) tabTotalPages = itemTotalPages;
                    }
                    if (!workFilterCurrentTab) this.props.updateMediaObjects({ workFilterCurrentTab: item });
                    this.setState({
                        data: data, itemSearch, tabCurrentPage: tabCurrentPage, tabTotalPages: tabTotalPages, tab: item.name,
                        searchFullText, resultText: searchFullText, tabClasses: { [item.name]: 'workfilter-active' }
                    }, () => this.checkTabPages());
                }
                this.setState({ [item.part]: workFilterObj[item.part] ? workFilterObj[item.part] : {} });
                this.updateResults({ tabName: item.name });
            })
        }

        updateResults = ({ tabName }) => {
            const { itemTotalItems, objectTotalItems } = this.props.mediaObjects;
            switch (tabName) {
                case ConfigTypes.TAB_ITEM:
                    this.setState({ [`${tabName}Results`]: itemTotalItems });
                    break;
                case ConfigTypes.TAB_OBJ:
                    this.setState({ [`${tabName}Results`]: objectTotalItems });
                    break;
                default:
                    break;
            }
        }

        startNewSearch = () => {
            window.location.reload();
        };

        onFormChange = (item) => (e) => {
            const { value } = e.target;
            this.setState({ form: { ...this.state.form, [item.field]: value } })
        }

        getListData = () => {
            const { itemlistOriginal, objectlistOriginal } = this.props.mediaObjects;
            let part = this.getCurrentPart(this.state.tab.name);
            let data = [];
            let listName = "";
            let listTotal = "";
            switch (part.name) {
                case ConfigTypes.PART_OBJ:
                    data = objectlistOriginal;
                    listName = "objectlist";
                    listTotal = "objectTotalItems";
                    break;
                case ConfigTypes.PART_ITEM:
                    data = itemlistOriginal;
                    listName = "itemlist";
                    listTotal = "itemTotalItems";
                    break;
                default:
                    break;
            }
            return { data, listName, listTotal };
        }

        checkFilterAndTabDisplay = () => {
            const { portalSearchRental } = this.props.mediaObjects;
            if (portalSearchRental) {
                this.searchByFieldsAndFullTxt({});
                this.setState({ cssStyle: { display: portalSearchRental ? ConfigTypes.NONE : ConfigTypes.FLEX } });
            }
        }

        checkItemFilter = ({ searchData = null }) => {
            const { portalSearchRental } = this.props.mediaObjects;
            if (portalSearchRental) {
                let data = [];
                if (searchData) data = searchData;
                else {
                    let list = this.getListData();
                    if (list && list.data) data = list.data;
                }

                let filteredData = [];
                if (data) {
                    filteredData = data.filter(el => {
                        if (checkRentItemFilter({ el })) return true;
                        return false;
                    })
                    return filteredData;
                }
            }
            return searchData ? searchData : [];
        }

        searchByFieldsAndFullTxt = ({ showAll = false }) => {
            let part = this.getCurrentPart(this.state.tab.name);
            let list = this.getListData();
            let data = [];
            if (list.data) data = list.data;
            if (this.state[part.name] && data) {
                for (let i in this.state[part.name]) {
                    if (!i.includes("_type") && !i.includes("_group") && !i.includes("_current")) {
                        data = data.filter(item => {
                            if (item && item.metadata && item.metadata.fields && item.metadata.fields[i]
                                && item.metadata.fields[i].toLowerCase().includes(this.state[part.name][i].toLowerCase())) {
                                return true;
                            }
                            let groupWith = this.state[part.name][`${i}_group`];
                            if (groupWith && item && item.metadata && item.metadata.fields && item.metadata.fields[groupWith]
                                && item.metadata.fields[groupWith].toLowerCase().includes(this.state[part.name][i].toLowerCase())) {
                                return true;
                            }
                            return false
                        })
                    }
                }
            }

            data = this.checkItemFilter({ searchData: data });
            this.props.updateMediaObjects({ [list.listName]: data, [list.listTotal]: data.length });
        }

        onUseFilter = () => {
            const { workFilterObj } = this.props.mediaObjects;
            this.searchByFieldsAndFullTxt({});
            let part = this.getCurrentPart(this.state.tab.name);
            let updatedObj = { ...workFilterObj, [part.name]: this.state[part.name] };
            this.props.updateMediaObjects({ workFilterObj: updatedObj });
        }

        onFullTextChange = (e) => {
            const { value, name } = e.target;
            this.setState({ searchFullText: value });
        }

        onResetFilter = () => {
            const { portalCurrentDDItem, portalWorkMain, workFilterObj } = this.props.mediaObjects;
            let fields = getSearchFields(portalCurrentDDItem, ConfigTypes.ASC);
            let updated = {};
            if (this.state.tab === ConfigTypes.TAB_ITEM) {
                if (portalWorkMain) fields.push(portalWorkMain);
                let searchParams = { fields, keyword: '' };
                updated.itemKeyword = '';
                updated.itemFields = fields;
            }
            if (this.state.tab === ConfigTypes.TAB_OBJ) {
                updated.objectKeyword = '';
                updated.objectFields = fields;
                updated.currentPage = 1;
            }

            let part = this.getCurrentPart(this.state.tab.name);
            updated.workFilterObj = { ...workFilterObj, [part.name]: {} };
            this.props.updateMediaObjects(updated);
            this.setState({ [part.name]: {}, searchFullText: '', resultText: '' }, () => this.searchByFieldsAndFullTxt({}));
        }

        showAll = () => {
            this.searchByFieldsAndFullTxt({ showAll: true });
        }

        getCurrentPart = (currentTab = false) => {
            let part = {};
            let tab;
            tab = this.state.tab
            if (currentTab) tab = currentTab;
            if (tab === ConfigTypes.TAB_ITEM) part.name = ConfigTypes.PART_ITEM;
            if (tab === ConfigTypes.TAB_OBJ) part.name = ConfigTypes.PART_OBJ;
            return part;
        }

        onTabClick = (tab) => () => {
            if (tab && tab.name) {
                let data = [];
                let itemSearch = false;
                let part = this.getCurrentPart(tab.name);
                if (this.state[`${part.name}_data`]) {
                    data = this.state[`${part.name}_data`];
                }
                if (tab.name === ConfigTypes.TAB_ITEM) itemSearch = true;
                let searchFullText = this.getTabFullText({ tab });
                this.setState({
                    tab: tab.name, itemSearch, searchFullText,
                    loading: true, tabClasses: { [tab.name]: 'workfilter-active' }
                }, () => {
                    this.setState({ data: data, loading: false });
                    this.searchByFieldsAndFullTxt({});
                });
                this.props.updateMediaObjects({ workFilterCurrentTab: tab });
            }
        }

        getTabFullText = ({ tab }) => {
            const { itemKeyword, objectKeyword } = this.props.mediaObjects;
            let searchFullText = objectKeyword || '';
            if (tab && tab.name) {
                if (tab.name === ConfigTypes.TAB_ITEM) {
                    searchFullText = itemKeyword;
                }
            }
            return searchFullText;
        }

        getResultsHeading = () => {
            const { portalCurrentDDItem } = this.props.mediaObjects;
            let heading = "Übersicht Suchergebnisse für ";
            let ddItem;
            if (portalCurrentDDItem && portalCurrentDDItem.intl) {
                ddItem = this.props.intl.formatMessage({ id: portalCurrentDDItem.intl });
            }

            return (
                <div>
                    {heading} <span className="workfilter-redbold">
                        {this.state.resultText ? this.state.resultText : `" "`}
                    </span>
                    {` (in "${ddItem}" gesucht)`}
                </div>
            )
        }

        showTabBtn = () => {
            return (
                <div className="workfilter-tab-top">
                    {
                        ConfigTypes.WORKFILTER_TABS.map((tab, i) => {
                            let htmlClasses = `workfilter-tab-btn ${this.state.tabClasses[tab.name]} ${this.props.showMore && 'workfilter-tab-inactive'}`
                            return (
                                <div className={htmlClasses} key={`workfilter_tabbtn${i}`}
                                    onClick={this.onTabClick(tab)} style={tab.checkDisplay && this.state.cssStyle}>
                                    {`${this.props.intl.formatMessage({ id: tab.intl })} 
                                (${this.state[`${tab.name}Results`] ? this.state[`${tab.name}Results`] : 0})`}
                                </div>
                            )
                        })
                    }
                </div>
            )
        }

        showListViewHeader = () => {
            let configName = ConfigTypes.OBJECT;
            let htmlClasses = "workfilter-header-box-list-object";
            if (this.state.tab === ConfigTypes.TAB_ITEM) {
                htmlClasses = "workfilter-header-box-list";
                configName = ConfigTypes.ITEM;
            }
            let showFields = getMetaConfig({
                viewMode: ConfigTypes.WORK_LIST,
                props: this.props,
                configName: configName
            });
            if (showFields && showFields.length) {
                return (
                    <div className={htmlClasses}>
                        {showFields.map((item, i) => {
                            return (<div className="workfilter-header-item-list" key={`workfilter_listview${i}`}>
                                {item.intl && this.props.intl.formatMessage({ id: item.intl })}
                            </div>)
                        })}
                    </div>
                )
            }
        }

        toggleViewMode = (view) => () => {
            this.setState({
                wpView: view,
                clStyles: { [view]: ConfigTypes.BTN_ACTIVE }
            });
            if (view === ConfigTypes.WORK_LIST) this.setState({ isListView: true });
            else this.setState({ isListView: false });
            this.props.updateMediaObjects({ wpView: view });
        }

        showTabBody = () => {
            if (!this.props.showMore && !this.state.loading) {
                return (
                    <div className="workfilter-listcontent-box">
                        {this.state.isListView && this.showListViewHeader()}
                        <div className="workfilter-listcontent">
                            {this.state.tab === ConfigTypes.TAB_ITEM ? <ItemList /> : <ObjectList />}
                        </div>
                    </div>
                )
            }
            return this.props.showLongDetails();
        }

        onNextClick = () => {
            const { worklist, currentWork } = this.props.mediaObjects;
            let nextIndex;
            let nextWork;
            if (worklist && worklist.length) {
                const workIndex = worklist.findIndex(work => +work.id === +currentWork.id);
                if (workIndex > -1) {
                    nextIndex = workIndex + 1;
                    nextWork = worklist[nextIndex];
                    if (nextWork && nextWork.id) {
                        let nextWorkId = nextWork.id;
                        //let nextWorkId = 4383;
                        this.props.updateMediaObjects({ viewMode: ConfigTypes.WORK_DETAIL, toTop: true });
                        this.props.getWork({ workId: nextWorkId });
                        this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${nextWorkId}`);
                    }
                }
            }
        }

        onBackClick = () => {
            this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST, toTop: true });
            if (!isHome()) this.props.router.navigate("/");
        }

        showBackNextBtn = () => {
            return (<div className="workfilter-navbtns">
                <div className="workfilter-back" onClick={this.onBackClick}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    {this.props.intl.formatMessage({ id: "searchfilter.showback" })}
                </div>
                <div className="workfilter-next" onClick={this.onNextClick}>
                    {this.props.intl.formatMessage({ id: "searchfilter.shownext" })}
                    <FontAwesomeIcon icon={faArrowRight} />
                </div>
            </div>)
        }

        showRightSide = () => {
            return (
                <div>
                    <div className="workfilter-top">
                        <div className="workfilter-tab">
                            {this.showTabBtn()}
                        </div>
                        <div className="workfilter-topright">
                            {/* {this.showBackNextBtn()} */}
                        </div>
                    </div>
                    {/* <div className="workfilter-results">
                        {this.getResultsHeading()}
                    </div> */}
                    <div className="workfilter-body">
                        {this.showTabBody()}
                    </div>
                    <div className="workfilter-footer">
                        <div></div>
                        {/* {this.showBackNextBtn()} */}
                    </div>
                </div>
            )
        }

        showFilterBtnActions = () => {
            return ConfigTypes.WORKFILTER_ACTIONS.map((item, i) => {
                return (
                    <AppButton key={`workfilterActions${i}`} className="workfilter-btn-filter"
                        btnTxt={this.props.intl.formatMessage({ id: item.intl })}
                        onClick={this[item.onClick]} icon={item.icon} />
                )
            })
        }

        onChangeHandler = ({ item, part }) => (e) => {
            const { value } = e.target;
            let groupWith;
            let wf = ConfigTypes.WORK_FILTER;
            if (item[`${wf}group`] && item[`${wf}group`].with) {
                groupWith = item[`${wf}group`].with;
            }
            this.setState({
                [part.name]: {
                    ...this.state[part.name],
                    [item.field]: value,
                    [`${item.field}_type`]: item[`${this.state.wpView}searchtype`],
                    [`${item.field}_group`]: groupWith
                }
            });
        };

        onDDClick = ({ item, part }) => (option) => {
            this.setState({
                [part.name]: {
                    ...this.state[part.name],
                    [item.field]: option.name,
                    [`${item.field}_current`]: option,
                    [`${item.field}_type`]: item[`${this.state.viewMode}searchtype`]
                }
            });
        }

        showDD = ({ part, item, i }) => {
            let groupClass = "workfilter-formcontrol";
            if (part.groupClass) groupClass = "workfilter-formgroup";
            let data = getDropdownData({ item, viewMode: this.state.viewMode });
            if (data)
                return (
                    <Form.Group className={groupClass} key={`workdfilterCatalog${i}`}
                        onKeyUp={this.onKeyUpFeld} controlId="workfilterForm.ControlInput1" >
                        {/* <Form.Label>{this.props.intl.formatMessage({ id: item.intl })}</Form.Label> */}
                        <div className="workfilter-dd-box">
                            <AppDropdown
                                data={data} current={this.state[part.name][`${item.field}_current`]}
                                onDDClick={this.onDDClick({ item, part })} />
                        </div>
                    </Form.Group>
                );
            return <div></div>
        }

        onKeyUpFeld = (e) => {
            if (e.key === ConfigTypes.ENTER) {
                this.onUseFilter();
            }
        }

        showInput = ({ part, item, i }) => {
            return (
                <Form.Group className="workfilter-formcontrol"
                    key={`searchfilter${i}`} onKeyUp={this.onKeyUpFeld}
                    controlId="exampleForm.ControlInput1">
                    {/* <Form.Label>{this.props.intl.formatMessage({ id: item.intl })}</Form.Label> */}
                    <Form.Control type={item.type}
                        onChange={this.onChangeHandler({ item, part })}
                        value={this.state[part.name] && this.state[part.name][item.field] ? this.state[part.name][item.field] : ""}
                        placeholder={this.props.intl.formatMessage({ id: item.intl })} />
                </Form.Group>
            );
        }

        showFilterComponents = () => {
            let part = this.getCurrentPart();
            return this.state.data && this.state.data.map((item, i) => {
                if (item[`${ConfigTypes.WORK_FILTER}type`] === 'dropdown') {
                    return this.showDD({ part, item, i });
                }
                return this.showInput({ part, item, i });
            });
        }


        showLeftSide = () => {
            if (!this.props.showMore) {
                let part = this.getCurrentPart();
                return (
                    <div>
                        {/* <AppButton icon={faSearch} className="workfilter-btn-search"
                            btnTxt={this.props.intl.formatMessage({ id: "searchfilter.button.search" })}
                            onClick={this.startNewSearch} /> */}

                        {/* <div className="workfilter-filterbox">
                            <input className="form-control" value={this.state.searchFullText}
                                onChange={this.onFullTextChange} type="text"
                                placeholder={this.props.intl.formatMessage({ id: "searchfilter.filter.search" })} />
                        </div> */}
                        {/* {this.state.data.map((item, i) => {
                            return (<Form.Group className="workfilter-formcontrol"
                                key={`searchfilter${i}`}
                                controlId="exampleForm.ControlInput1">
                                <Form.Label>{this.props.intl.formatMessage({ id: item.intl })}</Form.Label>
                                <Form.Control type={item.type}
                                    onChange={this.onChangeHandler({ item, part })}
                                    value={this.state[part.name] && this.state[part.name][item.field] ? this.state[part.name][item.field] : ""}
                                    placeholder={this.props.intl.formatMessage({ id: item.intl })} />
                            </Form.Group>)
                        } )} */}

                        {this.showFilterComponents()}
                        {this.showFilterBtnActions()}
                    </div>
                )
            }
        }

        checkTabPages = () => {
            const { itemTotalPages, totalPages, currentPage, itemCurrentPage } = this.props.mediaObjects;
            let isTabItem = this.state.tab === ConfigTypes.TAB_ITEM ? true : false;
            this.setState({ loading: true });
            let tabCurrentPage = currentPage;
            let tabTotalPages = totalPages;
            if (isTabItem) {
                tabCurrentPage = itemCurrentPage;
                tabTotalPages = itemTotalPages;
            }
            this.setState({ tabCurrentPage, tabTotalPages },
                () => {
                    this.checkFilterAndTabDisplay();
                    this.setState({ loading: false });
                });
        }


        componentDidUpdate(prev) {
            const { itemTotalItems, objectTotalItems, portalSearchRental }
                = this.props.mediaObjects;
            if (prev.mediaObjects.objectTotalItems != objectTotalItems) {
                this.updateResults({ tabName: ConfigTypes.TAB_OBJ });
                this.setState({ tabTotalItems: objectTotalItems });
                this.checkTabPages();
            }

            if (prev.mediaObjects.itemTotalItems != itemTotalItems) {
                this.updateResults({ tabName: ConfigTypes.TAB_ITEM });
                this.setState({ tabTotalItems: itemTotalItems });
                this.checkTabPages();
            }
        }

        componentDidMount() {
            this.initData();
        }

        render() {
            return (
                <div className="workfilter">
                    <div className="workfilter-wrapper">
                        {!this.props.showMore && (<div className="workfilter-left">
                            <Form>{this.showLeftSide()}</Form>
                        </div>)}
                        <div className="workfilter-right">
                            {this.showRightSide()}
                        </div>
                    </div>
                    {this.props.loading && (
                        <div className="workfilter-overlay">
                            <Spinner />
                        </div>)}
                </div>)
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    loading: state.media.mediaObjects.loading,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    searchObjects: (data) => dispatch(actions.searchObjects(data)),
    searchWorks: (data) => dispatch(actions.searchWorks(data)),
    getWork: (data) => dispatch(actions.getWork(data))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(WorkFilter))));

